<script>
    import { createEventDispatcher } from "svelte";
    import { estadosAuditar } from "../constants";
    import AuditoriaItemAuditarVer from "./AuditoriaItemAuditarVer.svelte";
    import NauiTag from "../../lib/naui/atoms/NauiTag.svelte";

    export let auditoriaItems;
    export let totalPages = 1;
    let archivo = "";
    export let itemsPerPage = 20;
    export let buscando = false;
    export let subruta;

    export let lista_defectos_primeras;

    export let is_administrador_auditoria;
    export let currentPage = 1;

    const dispatch = createEventDispatcher();
    
    const isPaqueteCompleto = subruta === "paqueteCompleto";
    const isMaquila = subruta === "maquila";

    $: totalItems = auditoriaItems.length 
    $: itemsToRender = auditoriaItems;
    $: auditoriaItems
    
    let refreshKeys = new Map(); // Mapa para almacenar claves únicas por ID
    let tableContainer; // Referencia al contenedor de la tabla

    function buscar() {
        dispatch("buscar", { page: currentPage });
    }
    async function RefrescarItem(id) {
        if (tableContainer) {
            const scrollPosition = tableContainer.scrollTop; // Captura la posición del scroll del contenedor
            const index = auditoriaItems.findIndex(item => item.id === id);
            if (index !== -1) {
                const itemToDelete = auditoriaItems[index];
                auditoriaItems = [
                    ...auditoriaItems.slice(0, index),
                    ...auditoriaItems.slice(index + 1)
                ];
                await new Promise(resolve => requestAnimationFrame(resolve));
                auditoriaItems = [
                    ...auditoriaItems.slice(0, index),
                    itemToDelete,
                    ...auditoriaItems.slice(index)
                ];
                tableContainer.scrollTop = scrollPosition; // Restaura la posición del scroll del contenedor
            }
        }
    }

</script>

<div bind:this={tableContainer} style="overflow-y: auto; max-height: 80vh;">
    <table class="naui-table w-100">
        <thead>
            <tr>
                <th> Vendor </th>
                {#if isPaqueteCompleto }
                <th>PO</th>
                {/if}

                <th> Referencia </th>
                {#if isMaquila }
                <th> Tipo Auditoría </th>
               
                <th> Liq. Ref. </th>
                {/if}
                <th> Tamaño Muestra </th>
                <th width="1%"> Tipo de Empaque </th>
                <th width="100px"> Q </th>

                {#if isMaquila }
                <th width="100px"> Orden de Corte </th>
                <th width="1%" colspan="2"> Crítica Auditada </th>
                {/if}
                <th width="1%"> Cant. </th>
                {#if isMaquila }
                <th width="1%"> Cant. Aud. </th>
                <th width="1%"> Cant. Seg. </th>
                {/if}
                <th width="150px"> Estado </th>
                <th width="155px"> Fecha </th>
                <th> Hora </th>
                <th width="110px"> Nombre Auditor </th>
                <th width="100px"> Observación </th>
                <th width="1%" colspan="3"> Medida Empaque Confección </th>
                <th width="1%"> Auditar </th>
            </tr>
        </thead>
        <tbody>
            {#if !buscando && auditoriaItems.length === 0}
                <tr>
                    <td colspan="20">
                        <div><p>No se encontraron registros</p></div>
                    </td>
                </tr>
            {:else if auditoriaItems.length > 0}
                {#each itemsToRender as item (item.id)}
                    <AuditoriaItemAuditarVer
                        key={refreshKeys.get(item.id) || 0}
                        data={item}
                        bind:checked={item.checked}
                        estados={estadosAuditar}
                        archivo={archivo.split("/").pop().split("\\").pop()}
                        on:Eauditar={buscar}
                        on:RefrescarItem={() => RefrescarItem(item.id)}
                        subruta={subruta}
                        lista_defectos_primeras = {lista_defectos_primeras}
                        is_administrador_auditoria = {is_administrador_auditoria}
                    />
                {/each}
            {:else}
                <tr>
                    <td colspan="20">
                        <div><p>Buscando...</p></div>
                    </td>
                </tr>
            {/if}
        </tbody>
        
    </table>
</div>

